var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownChevronGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4745 5.25628C12.8235 4.91457 13.3893 4.91457 13.7383 5.25628C14.0872 5.59799 14.0872 6.15201 13.7383 6.49372L8.63188 11.4937C8.2829 11.8354 7.7171 11.8354 7.36812 11.4937L2.26173 6.49372C1.91276 6.15201 1.91276 5.59799 2.26173 5.25628C2.61071 4.91457 3.17652 4.91457 3.5255 5.25628L8.00244 9.63996L12.4745 5.25628Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4773_64002",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 12,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4745 5.25628C12.8235 4.91457 13.3893 4.91457 13.7383 5.25628C14.0872 5.59799 14.0872 6.15201 13.7383 6.49372L8.63188 11.4937C8.2829 11.8354 7.7171 11.8354 7.36812 11.4937L2.26173 6.49372C1.91276 6.15201 1.91276 5.59799 2.26173 5.25628C2.61071 4.91457 3.17652 4.91457 3.5255 5.25628L8.00244 9.63996L12.4745 5.25628Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4773_64002)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    width: 16,
    height: 16,
    fill: "#BAC0CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevronGrey);
export default __webpack_public_path__ + "static/media/down-chevron-grey.1643e37faf435d4fd4470b1cd350747f.svg";
export { ForwardRef as ReactComponent };